<sh-card label="SeSO Applications">
  <app-refresh-data-sources-button
    slot="functions"
    [apiCall]="systemOverviewService.companions"
    (didChange)="indicateRefresh($event)"
  ></app-refresh-data-sources-button>
  <api-call-gate [apiCall]="companions">
    <ng-template #lastSuccessfulData let-companions>
      <div class="items">
        <div
          class="item"
          *ngFor="let companion of companions"
          [attr.flash]="changedApps.has(companion.title) || null"
        >
          <sh-tool
            [disabled]="isCompanionDisabled(companion)"
            [icon]="'url(' + companion.icon + ')'"
            [label]="companion.title"
            [href]="companion.link | processPlaceholders"
            (click)="
              !isCompanionDisabled(companion) &&
                open($event.target.href, companion)
            "
          ></sh-tool>

          <div [id]="getCompanionId(companion)">
            <sh-text size="body-2" top-line color="secondary"
              >Last update</sh-text
            >
            <sh-text size="body-2">{{
              getTimeFromNow(companion.lastUpdate)
            }}</sh-text>
          </div>
        </div>
      </div>
    </ng-template>
  </api-call-gate>
</sh-card>
